module.exports = __webpack_public_path__ + "img/53e57.60988369.png";